<template>
  <el-dialog
    :visible="detailDialogVisible"
    title="启动页配置详情"
    width="800px"
    @open="openDialog"
    @close="closeDialog"
     :before-close="handleClose"
  >
    <!-- <el-form
      :model="bannerDetail"
      ref="bannerForm"
      class="banner-form"
      :rules="rules"
      label-width="200px"
    >
      <el-form-item label="广告位置：" prop="type">
        <el-select :value="bannerDetail.type" @change="handleFormChange('type', $event)" placeholder="请选择">
          <el-option
            v-for="item in positionTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <div class="flex_div">
        <el-form-item label="场景：" prop="type">
          <el-select
            :value="bannerDetail.type"
            @input="handleFormChange('type', $event)"
            placeholder="请选择"
          >
            <el-option
              v-for="item in bannerTypes"
              :key="item.type"
              :label="item.message"
              :value="Number(item.type)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类型：" prop="bannertype">
          <el-select v-model="bannerDetail.bannerType" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </div>
      <el-form-item label="标题：" prop="title">
        <el-input
          :value="bannerDetail.title"
          @input="handleFormChange('title', $event)"
        ></el-input>
      </el-form-item>
      <el-form-item label="图片：" prop="imageUrl">
        <upload
          :value="bannerDetail.imageUrl"
          @change="handleFormChange('imageUrl', $event)"
          :data="{
            language: this.bannerDetail.language,
            platform: this.bannerDetail.platform,
            category: 'banner',
          }"
        ></upload>
      </el-form-item>
      <el-form-item label="跳转地址：" prop="linkUrl">
        <el-input
          :value="bannerDetail.linkUrl"
          @input="handleFormChange('linkUrl', $event)"
        ></el-input>
      </el-form-item>
    </el-form> -->
    <el-form
        :model="updateDetail"
        ref="startPageForm"
        class="banner-form"
        :rules="rules"
        label-width="180px"
      >
       
        <div class="flex_div">
        <el-form-item label="配置类型：" prop="confType">
          <el-select v-model="updateDetail.confType" placeholder="请选择">
            <el-option
              v-for="item in confTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="跳转类型：" prop="type">
           <!-- <el-input v-model="updateDetail.type"></el-input> -->
          <el-select v-model="updateDetail.type" placeholder="请选择">
            <el-option
              v-for="item in toOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        </div>
        <div class="flex_div">
         <el-form-item label="平台区分：" prop="platform">
          <el-select v-model="updateDetail.platform"  placeholder="请选择">
            <el-option
              v-for="item in platformOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
       
        </div>
       
        <div class="flex_div btn">
          <el-form-item label="是否登录：" prop="login">
            <el-switch
              v-model="updateDetail.login"
              active-color="#13ce66"
              >
            </el-switch>
          </el-form-item>
          <el-form-item label="是否开启：" prop="confOpen">
            <el-switch
              v-model="updateDetail.confOpen"
              active-color="#13ce66"
            >
            </el-switch>
          </el-form-item>
        </div>
         <el-form-item label="显示名称：" prop="displayName">
          <el-input v-model="updateDetail.displayName"></el-input>
        </el-form-item>
        <el-form-item label="icon图标" prop="icon">
          <upload v-model="updateDetail.icon" :data="query"></upload>
        
          <img v-if="updateDetail.confValue[0].icon!=null" 
          class="img" :src="updateDetail.confValue[0].icon" alt="暂无图片">
        </el-form-item>
        <div class="flex_div">
          <el-form-item label="地址选择：" prop="urlType" class="url">
            <el-select v-model="urlType" 
            @change="changeUrl($event)"
            placeholder="请选择地址" 
            class="url_select">
              <el-option
                v-for="item in urloptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          <el-input v-model="urlDetail" style="width: 358px;"></el-input>
        </el-form-item>
        </div>
        
        <div class="flex_div">
           <el-form-item label="最低版本：" prop="verL">
          <el-input v-model="updateDetail.verL"></el-input>
        </el-form-item>
        <el-form-item label="最高版本：" prop="verH">
          <el-input v-model="updateDetail.verH"></el-input>
        </el-form-item>
        </div>
       
      </el-form>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="toggleDetailDialogVisible(false)">取消</el-button>
      <el-button type="primary" @click="handleSave('startPageForm')"
        >保存</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import Upload from "components/upload";

export default {
  name: "BannerDetail",
  props: ["valueDeatil"],
  data() {
    return {
        confObj:{},
         urlType:'',
      urlDetail:'',
      updateDetail:{},
      rules: {
        confType: [{ required: true, message: "配置类型不能为空！" }],
        // icon: [{ required: true, message: "图标地址不能为空！" }],
        title: [{ required: true, }],
        type: [{ required: true, message: "跳转类型(app内部模块)不能为空！" }],
        displayName: [{ required: true, message: "显示名称不能为空！" }],
       
      },
       urloptions:[
        {   
          value: 'url',
          label: "全局地址",
        },
        {   
          value: 'urlAppend',
          label: "相对地址",
        },
      ],
      confTypeOptions:[
       {   
          value: 1,
          label: "启动页",
        },
       {   
          value: 2,
          label: "广告页",
        },
       {   
          value: 3,
          label: "金刚区",
        },
      ],
      platformOptions:[
        {   
          value: 0,
          label: "安卓",
        },
       {   
          value: 1,
          label: "苹果",
        },
      ],
      toOptions:[
         {
          value: '1',
          label: "H5",
        },
        {
          value: '2',
          label: "移动端",
        },
      ],
      options: [
        {
          value: "image",
          label: "图片",
        },
        {
          value: "custom",
          label: "自定义",
        },
      ],
    };
  },
  components: {
    Upload,
  },
  watch: {
    valueDeatil:{
      handler(val,oldVal){
       
        this.updateDetail={...val,login:Boolean(val.login)}
       
        if(val.confValue[0]&&val.confValue[0].url){
          this.urlDetail=val.confValue[0].url
          this.urlType='url'
          return
        }
        if(val.confValue[0]&&val.confValue[0].urlAppend){
          this.urlDetail=val.confValue[0].urlAppend
           this.urlType='urlAppend'
          return
        }
      },
      immediate:true,
      deep:true
    }
  },
  computed: {
    ...mapState("startPageSetting", [
      "detailDialogVisible",
      "positionTypeList",
      "platformTypeList",
      "languageList",
      "query",
      "bannerTypes",
    ]),
    ...mapGetters("startPageSetting", ["bannerDetail", "bannerList"]),
  },
  methods: {
    ...mapActions("startPageSetting", ["detail", "update", "list",'getStartPageUpdate']),
    ...mapMutations("startPageSetting", [
      "toggleDetailDialogVisible",
      "setBannerDetail",
    ]),
    openDialog() {
      // this.detail(this.value);
    },
    closeDialog() {
      this.toggleDetailDialogVisible(false);
    },
     changeUrl(e){
      if(e=='url'){
        this.urlDetail=this.updateDetail.confValue[0][e]
      }
      if(e=='urlAppend'){
        this.urlDetail=this.updateDetail.confValue[0][e]
      }
     }
,    handleFormChange(type, value) {
      this.setBannerDetail({
        ...this.bannerDetail,
        [type]: value,
      });
    },
    handleSave(formName) {
      const obj={...this.updateDetail,login:Number(this.updateDetail.login)}
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.getStartPageUpdate(obj).then(res=>{
           
               this.$message({
              message: "修改成功！",
              type: "success",
            });
            this.toggleDetailDialogVisible(false);
            this.$emit("refresh");
            
            
          })
        }
      });
    },
    handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      }
  },
};
</script>

<style lang="less" scoped>
.banner-form {
  margin-right: 100px;
}
.flex_div {
  display: flex;
}
.btn{
  justify-content: space-between;
}
.url{
  justify-content: space-between;
}
.url_select{
  width: 120px;
}
.img{
  width: 100px;
    height: 100px;
}
</style>
